/* Produkt-Tabs in die Bildspalte holen - Fahrrad Rachow
 *
 * Auf dem Desktop steht unter den Produktbildern viel leerer Raum (bei einem
 * typischen Rad rund 490px), weil die rechte Infospalte deutlich höher ist.
 * Die Tabs "Produktdetails / Eigenschaften" liegen darunter als eigener
 * Abschnitt über die volle Breite. Dieses Skript verschiebt sie in den freien
 * Raum. Gemessene Ersparnis auf einer Produktseite: 357px Seitenhöhe.
 *
 * Warum per JavaScript und nicht im Liquid:
 * Die Tabs sind ein eigenständiger Abschnitt mit eigenen Einstellungen (Tab-
 * Inhalte, Icons, Popup-Texte), die im Theme-Editor gepflegt werden. Ein
 * Abschnitt kann in Liquid nicht innerhalb eines anderen Abschnitts gerendert
 * werden. Die Tabs stattdessen in main-product.liquid einzubauen würde
 * bedeuten, sie als Blöcke nachzubauen und alle Inhalte zu migrieren - die
 * Pflege im Theme-Editor ginge dabei verloren. Deshalb bleibt der Abschnitt
 * unangetastet und wird nur umgehängt.
 *
 * WICHTIG - warum in .product__column-sticky hinein und nicht daneben:
 * Die Bildspalte ist position:sticky. Hängt man die Tabs als Geschwister
 * darunter, laufen die mitscrollenden Bilder über sie hinweg (gemessen: 499px
 * Überlappung). Innerhalb des Sticky-Blocks bilden Bilder und Tabs eine
 * Einheit und das passiert nicht.
 */
(() => {
  'use strict';

  /* Ab dieser Breite stehen Bild- und Infospalte nebeneinander und die
     Bildspalte ist sticky. Darunter wird nichts verschoben. */
  const DESKTOP = '(min-width: 990px)';

  const STYLES = `
    .tabs-in-column .custom-tabs-section-bg {
      margin: 22px 0 0;
      padding: 24px 0;
      border-radius: 8px;
    }
    .tabs-in-column .custom-tabs-wrapper {
      max-width: none;
      margin: 0;
      padding: 0 22px;
    }
  `;

  document.addEventListener('DOMContentLoaded', () => {
    const section = Array.from(document.querySelectorAll('.shopify-section')).find((el) =>
      el.id.indexOf('custom_product_tabs') !== -1
    );
    const target = document.querySelector('.product__column-sticky');

    /* Ohne Sticky-Block nicht verschieben - siehe Überlappung oben. */
    if (!section || !target) return;

    const style = document.createElement('style');
    style.textContent = STYLES;
    document.head.appendChild(style);

    /* Ursprungsplatz merken, damit auf schmalen Fenstern sauber zurückgehängt
       werden kann. */
    const home = { parent: section.parentElement, next: section.nextElementSibling };
    const mq = window.matchMedia(DESKTOP);

    function place() {
      if (mq.matches) {
        if (section.parentElement !== target) {
          target.appendChild(section);
          section.classList.add('tabs-in-column');
        }
      } else if (section.parentElement !== home.parent) {
        home.parent.insertBefore(section, home.next);
        section.classList.remove('tabs-in-column');
      }
    }

    place();

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', place);
    } else {
      mq.addListener(place);
    }
  });
})();

/* Beim Umschalten/Aufklappen der Tabs an den Anfang des Inhalts springen (seit 2026-10-02).
 * Ohne das landet man z. B. bei "Eigenschaften" mitten in der Tabelle:
 * - Desktop: Die Tabs sitzen in der mitlaufenden Bildspalte. Wird der Inhalt länger,
 *   springt die Spalte an ihren normalen Platz zurück und der Tab-Anfang liegt über dem Fenster.
 * - Handy: Der offene Reiter darüber klappt zu und schiebt alles nach oben.
 * Läuft nach den Klick-Handlern des Abschnitts (Bubble-Phase am document). */
(() => {
  'use strict';

  function offsetTop() {
    const header = document.querySelector('.section-header');
    const pos = header ? getComputedStyle(header).position : '';
    return (pos === 'sticky' || pos === 'fixed' ? header.offsetHeight : 0) + 16;
  }

  function keepInView(el) {
    if (!el) return;
    const offset = offsetTop();
    const top = el.getBoundingClientRect().top;
    if (top < offset || top > window.innerHeight - 120) {
      window.scrollTo({ top: Math.max(0, window.scrollY + top - offset), behavior: 'instant' });
    }
  }

  /* Handy: Der zuklappende Reiter würde 0,3 s animieren - so lange stünde die Position
     des neuen Reiters nicht fest. Deshalb klappt er ohne Animation zu. */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest && e.target.closest('.custom-tabs-wrapper .accordion-toggle');
    if (!toggle) return;
    const own = toggle.closest('.tab-item');
    toggle.closest('.custom-tabs-wrapper').querySelectorAll('.tab-item.mobile-active').forEach((item) => {
      if (item === own) return;
      const body = item.querySelector('.tab-body');
      if (!body) return;
      body.style.transition = 'none';
      requestAnimationFrame(() => requestAnimationFrame(() => { body.style.transition = ''; }));
    });
  }, true);

  document.addEventListener('click', (e) => {
    if (!e.target.closest) return;
    const tabBtn = e.target.closest('.custom-tabs-wrapper .tab-button');
    if (tabBtn) {
      keepInView(tabBtn.closest('.tabs-nav') || tabBtn);
      return;
    }
    const toggle = e.target.closest('.custom-tabs-wrapper .accordion-toggle');
    if (toggle && toggle.classList.contains('open')) keepInView(toggle);
  });
})();

/* „Garantie“ / „Versand & Retoure“ (Icon-Leiste unter den Tabs) als Fenster von unten,
 * genau wie Produktservices und „Fragen zum Produkt“ (seit 2026-10-04).
 * Inhalte bleiben im Theme-Editor gepflegt (Abschnitt „Produkt Tabs + Popups“): Aus jedem alten
 * Popup (.custom-tabs-modal) wird beim Laden ein <dialog class="rps-modal"> gebaut; Rahmen und
 * Animation kommen aus rachow-product-services.css. openSectionModal() öffnet dann dieses Fenster. */
(() => {
  'use strict';

  const STYLES = `
    .rpt-modal .rps-modal__hero { grid-template-columns: 1fr; padding-bottom: 28px; }
    .tabs-icon-bar .icon-item:focus-visible { outline: 2px solid var(--rc-ink, #21363d); outline-offset: 3px; border-radius: 2px; }
  `;
  const CLOSE_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  const html = document.documentElement;
  const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function close(d) {
    if (!d.open || d.classList.contains('is-closing')) return;
    html.classList.remove('rps-lock');
    const done = () => { d.classList.remove('is-closing'); d.close(); };
    if (calm) return done();
    d.classList.add('is-closing');
    setTimeout(done, 280);
  }

  function build(old) {
    const id = 'rpt-' + old.id;
    if (document.getElementById(id)) return;
    const title = old.querySelector('.modal-headline');
    const content = old.querySelector('.modal-content-text');
    const d = document.createElement('dialog');
    d.className = 'rps-modal rpt-modal';
    d.id = id;
    d.setAttribute('aria-labelledby', id + '-title');
    d.innerHTML =
      '<button type="button" class="rps-modal__close" aria-label="Schließen">' + CLOSE_SVG + '</button>' +
      '<div class="rps-modal__scroll"><header class="rps-modal__hero"><h2 class="rps-modal__title"></h2></header>' +
      '<div class="rps-modal__body"></div></div>';
    const h = d.querySelector('.rps-modal__title');
    h.id = id + '-title';
    h.textContent = title ? title.textContent.trim() : '';
    if (content) d.querySelector('.rps-modal__body').innerHTML = content.innerHTML;
    d.querySelector('.rps-modal__close').addEventListener('click', () => close(d));
    d.addEventListener('click', (e) => { if (e.target === d) close(d); });
    d.addEventListener('cancel', (e) => { e.preventDefault(); close(d); });
    d.addEventListener('close', () => html.classList.remove('rps-lock'));
    document.body.appendChild(d);
  }

  function init() {
    const olds = document.querySelectorAll('.custom-tabs-modal');
    if (!olds.length || typeof HTMLDialogElement === 'undefined') return;

    const style = document.createElement('style');
    style.textContent = STYLES;
    document.head.appendChild(style);
    olds.forEach(build);

    const fallback = window.openSectionModal;
    window.openSectionModal = function (modalId) {
      const d = document.getElementById('rpt-' + modalId);
      if (!d) return fallback && fallback(modalId);
      if (!d.open) d.showModal();
      html.classList.add('rps-lock');
    };

    /* Icon-Einträge sind <div>s: per Tastatur erreichbar machen */
    document.querySelectorAll('.tabs-icon-bar .icon-item').forEach((el) => {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-haspopup', 'dialog');
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
      });
    });
  }

  /* Nach dem Abschnitts-Skript laufen (das hängt die Popups bei DOMContentLoaded an <body>) */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(init, 0));
  } else {
    init();
  }
})();
